var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 23.03749,
    viewBox: "0 0 50 23.03749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m49.86866,11.49498c-.51108-2.26565-2.09387-4.30213-4.83874-6.22573-.00292-.002-.00576-.004-.00868-.00592C40.18685,2.02198,33.42334.15595,25.97664.00895c-7.19816-.14149-14.25166,1.39992-19.35245,4.23155C4.43688,5.46739-.5819,8.82937.05549,13.53805c.03404.25195.2477.44083.5019.44384.25354.00234.4722-.18087.51216-.43191.35807-2.2453,2.12775-4.10816,5.40338-5.69171,2.98114-1.38694,6.53606-2.35414,10.62203-2.89391-1.77648,1.91958-2.86273,4.4872-2.86273,7.30892,0,5.94491,4.8193,10.76421,10.76421,10.76421s10.76421-4.8193,10.76421-10.76421c0-2.81715-1.08271-5.38107-2.85408-7.29963,5.87962.79068,11.72148,2.55189,14.61767,5.72126.75778.85405,1.24141,1.84067,1.39875,2.85307.03879.2497.2537.43383.50632.43391h.00017c.25254,0,.46753-.18396.50649-.43358.1037-.665.08151-1.35379-.06733-2.05333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.ed21e767aaa2c7fb9c5d9a4bab3b0f15.svg";
export { ForwardRef as ReactComponent };